// ======================================================================
// File: frontend/src/modules/ppe/pages/procurement/indent/services/materialService.js
// Module: PPE → Procurement → Indent
//
// Purpose:
// - Search materials for indent item drawer
// - RAW_MATERIAL → raw_material master
// - BOUGHT_OUT   → bought_out master
//
// Backend APIs:
// - /api/ppe/masters/raw-materials/search
// - /api/ppe/masters/boughtout-items/search
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

// ------------------------------------------------------------
// RAW MATERIAL SEARCH
// ------------------------------------------------------------
export async function searchRawMaterials(q) {
  const res = await axiosClient.get(
    "/api/ppe/masters/raw-materials/search",
    { params: { q } }
  );

  // Backend returns:
  // { id, material_code, material_name, issue_uom_name }

  return (res.data?.data || []).map((r) => ({
    value: r.id,
    label: `${r.material_name} - ${r.issue_uom_name || ""}`,
    uom: r.issue_uom_name,
  }));
}

// ------------------------------------------------------------
// BOUGHT OUT ITEM SEARCH
// ------------------------------------------------------------
export async function searchBoughtOutItems(q) {
  const res = await axiosClient.get(
    "/api/ppe/masters/boughtout-items/search",
    { params: { q } }
  );

  // Backend returns:
  // { id, code, name, uom_name }

  return (res.data?.data || []).map((r) => ({
    value: r.id,
    label: `${r.name} - ${r.uom_name || ""}`,
    uom: r.uom_name,
  }));
}
